import { Button } from '@/components'
import { Dialog } from '@/components/UI/Dialog'
import dialogStyles from '@/components/UI/Dialog.module.css'
import type { SpotPointStatusItem } from '@/domain/stamp/spotPointStatus'
import type { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { SpotPointStatusList } from './SpotPointStatusList'

type Props = {
  items: SpotPointStatusItem[]
  isOpen: boolean
  onClose: () => void
  /** スポット名タップ時に呼ばれる。spotId を渡す */
  onSelectSpot?: (spotId: number) => void
}

/** スポットごとの獲得状況ダイアログ（#3582）。外枠は DialogPointHistory に揃える */
export const DialogSpotPointStatus: FC<Props> = ({ items, isOpen, onClose, onSelectSpot }) => {
  const { t } = useTranslation()

  // DialogPointHistory と同じく、遷移を呼んでからダイアログを閉じる（他の行の二重タップを防ぐ）
  const handleSelectSpot = onSelectSpot
    ? (spotId: number) => {
        onSelectSpot(spotId)
        onClose()
      }
    : undefined

  return (
    <Dialog
      selectorState={isOpen}
      closeFunc={onClose}
      title={t('home.collected_status_in_each_spot', 'スポットごとの獲得状況')}
    >
      {/* タイトル〜リストの余白（24px）。タイトル上の24pxは Dialog header の paddingTop が担う */}
      <div className="mt-6">
        {/* scrollArea が Dialog body の padding を打ち消し、スクロールバーをダイアログ端に寄せる */}
        <div className={`${dialogStyles.scrollArea} max-h-[60vh]`}>
          <SpotPointStatusList items={items} onSelectSpot={handleSelectSpot} />
        </div>
        {/* リスト〜ボタンの余白（24px）。ボタン下の24pxは Dialog body の paddingBottom が担うため pb-* は付けない */}
        <div className="mt-6 w-full">
          <Button label={t('common.ok', 'OK')} variant="primary" size="md" fullWidth onClick={onClose} />
        </div>
      </div>
    </Dialog>
  )
}
